// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eb1c3cea","455":"8447917b","977":"3f61236c"}[chunkId] + ".chunk.js";
};